import apiClient from '../apis'

export function switchProject(projectId) {
    return apiClient.user.switchProject(projectId)
}

export function getProfile() {
    return apiClient.user.getProfile()
}
